export default __webpack_public_path__ + "static/media/mobile-solid.7347db83.svg";